/**
 * Filter param names that should use single-selection (radio behavior).
 * Examples: 'filter.v.option.color', 'filter.v.option.size', 'filter.p.vendor'
 * Leave empty [] to apply to ALL list filters.
 * 
 * NOTE: Logic for hidding single item filters is on blocks/fitlers.liquid
 */
(function PATCH_filtersAsRadios() {
  // ─── Configuration ────────────────────────────────────────────────────────
  // Only these filter groups will behave as single-select (radio-style).
  // All other filters retain their default multi-select (checkbox) behavior.
  const SINGLE_SELECT_FILTERS = [
    'filter.p.m.custom.series',   // Scored, Picnic, etc.
    'filter.p.m.ceramics.form',   // Plate, Bowl, etc.
    'filter.p.m.ceramics.pattern',
    'filter.p.m.ceramics.clay',
    'filter.p.m.ceramics.glaze',
  ];
  // ──────────────────────────────────────────────────────────────────────────

  // Track modifier key state
  let multiSelectActive = false;

  document.addEventListener('keydown', (e) => {
    if (e.shiftKey || e.ctrlKey || e.metaKey) multiSelectActive = true;
  });

  document.addEventListener('keyup', (e) => {
    if (!e.shiftKey && !e.ctrlKey && !e.metaKey) multiSelectActive = false;
  });

  // Reset if window loses focus (e.g. user cmd+tabs away)
  window.addEventListener('blur', () => { multiSelectActive = false; });

  function applyRadioBehavior(filterForm) {
    filterForm.addEventListener('click', (e) => {
      const target = e.target.closest('input[type="checkbox"], label, a[data-filter]');

      if (!target) return;

      // If a multi-select modifier is held, let default behavior run
      if (multiSelectActive) return;

      // Resolve the checkbox element from the click target
      let checkbox = null;

      if (target.tagName === 'INPUT' && target.type === 'checkbox') {
        checkbox = target;
      } else if (target.tagName === 'LABEL' && target.htmlFor) {
        checkbox = filterForm.querySelector(`#${CSS.escape(target.htmlFor)}`);
      }

      if (!checkbox) return;

      const filterName = checkbox.name;
      if (!SINGLE_SELECT_FILTERS.includes(filterName)) return;

      // After a click, the browser has already toggled the checkbox.
      // So checked=true means it was just selected — that's when we act.
      // checked=false means it was just deselected — let it go normally.
      if (!checkbox.checked) return;

      // The checkbox is now checked. Uncheck all siblings silently —
      // the filter:update interceptor will handle the rest.
      const siblings = Array.from(
        filterForm.querySelectorAll(
          `input[type="checkbox"][name="${CSS.escape(filterName)}"]`
        )
      );

      siblings.forEach((cb) => {
        if (cb !== checkbox && cb.checked) {
          cb.checked = false;
          // Dispatch change so Horizon's JS sees the deselection
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // Tell the filter class to update the status bar
      cb.dispatchEvent(new Event('filter:update'));
    });
  }

  const filterForms = document.querySelectorAll(
    '#FacetFiltersForm, #FacetFiltersFormMobile, form[id*="Facet"], form[id*="facet"]'
  );
  filterForms.forEach(applyRadioBehavior);
})();
